import Paho from 'paho-mqtt';

const MqttApi = {
  Client: null,
  MqttSate: false,
  parameter: {
    ip: window.location.host.split(':')[0],
    port: 1885,
    ClientID: '',
    username: 'iiws',
    password: 'iiws',
  },
  callbackObject: [],
  init: function () {
    let that = this;
    that.Client = new Paho.Client(
      //'ws://127.0.0.1:8083/mqtt',
      `${
        window.location.protocol === 'http:'
          ? 'ws://mqttbroker.tmplascloud.com:1886/mqtt'
          : 'wss://mqttbroker.tmplascloud.com:1885/mqtt'
      }`,
      that.parameter.ClientID || new Date().getTime() + ''
    );
    that.Client.onConnectionLost = that.onConnectionLostS; // 注册连接丢失
    that.Client.onMessageArrived = that.onMessageArrivedS; // 注册消息接收
    that.Client.onMessageDelivered = that.onMessageDeliveredS; // 注册消息传递
    that.Client.connect({
      timeout: 40, // 连接超时时间/秒
      keepAliveInterval: 1800, // 1800秒内没有活动自动断开连接 默认值为60秒 心跳
      cleanSession: true, // 如果为true(默认值)，则在成功连接时删除客户端和服务器持久化状态
      useSSL: false, // 如果存在且为true，则使用SSL Websocket连接
      invocationContext: {}, // 传递给onSuccess回调或onFailure回调
      userName: that.parameter.username,
      password: that.parameter.password,
      onSuccess: that.onConnect, // 注册连接成功
      onFailure: function (err) {
        console.warn('Mqtt connection fail', err);
      }, // 连接失败事件
      reconnect: true, // 设置如果连接丢失，客户端是否自动尝试重新连接到服务器 如果设置为false，当连接丢失时，客户端将不会尝试自动重新连接到服务器。  如果设置为true，当连接丢失时，客户端将尝试重新连接服务器。 在尝试重新连接之前，它最初将等待1秒，对于每一次失败的重新连接尝试，延迟将加倍，直到达到2分钟，此时延迟将保持在2分钟。
      // hosts: [], // 如果存在，它包含一组主机名或完全限定的WebSocket uri (ws://mqtt.eclipse.org:80/mqtt)，这些uri将在构造函数上的主机和端口参数的位置依次尝试。 主机被尝试在一个时间顺序，直到其中一个成功
      // ports: [], // 如果提供与主机匹配的端口集。 如果主机包含uri，则不使用此属性。
      // mqttVersion: number, // 用于连接到MQTT代理的MQTT版本。
      // mqttVersionExplicit: boolean, // 如果设置为true，将强制连接使用所选的MQTT版本，否则将连接失败。
      // uris: [] // 如果有，应该包含一个完全限定的WebSocket uri列表(例如:ws://mqtt.eclipse.org:80/mqtt)，这些uri将在构造函数的host和port参数的位置依次尝试。 uri按顺序依次尝试一个，直到其中一个成功。 不要将此属性与主机一起使用，因为主机阵列将被转换为uri，并将覆盖此属性。
    });
  },
  onConnect: function (res) {
    MqttApi.MqttSate = true;
    console.log('Mqtt successfu lconnection', res);
  },
  onMessageDeliveredS: function (res) {
    // console.log("Mqtt Message passing detected",res);
  },
  onConnectionLostS: function (res) {
    MqttApi.MqttSate = false;
    console.warn('A lost connection will automatically reconnect', res);
  },
  onMessageArrivedS: function (res) {
    if (res.payloadBytes) {
      res.data = MqttApi.Uint8ArrayToString(res.payloadBytes);
    }
    MqttApi.callbackObject.forEach((item, index) => {
      if (item.topic === res.topic) {
        item.callback(res);
        MqttApi.callbackObject.splice(index, 1);
      }
    });
  },
  publishApi: function (obj) {
    if (!this.MqttSate) {
      console.warn('MQTT is automatically republished after three seconds of non-connection');
      setTimeout(() => {
        MqttApi.publishApi(obj);
      }, 3000);
      return;
    }
    if (obj.payload) {
      obj.payload = JSON.stringify(obj.payload);
    } else {
      obj.payload = JSON.stringify({
        id: 1,
        version: '1.0',
        method: 'thing.sub.list',
        params: {},
      });
    }
    this.Client.publish(obj.topic, obj.payload, 0, true);
  },
  subscriptionApi: function (obj, callback) {
    if (!this.MqttSate) {
      console.warn('MQTT automatically resubscribes after being disconnected for three seconds');
      setTimeout(() => {
        MqttApi.subscriptionApi(obj, callback);
      }, 3000);
      return;
    }
    MqttApi.callbackObject.push({
      topic: obj.topic,
      callback: callback,
    });
    this.Client.subscribe(obj.topic, {
      qos: 0,
      invocationContext: {},
      onSuccess: function (res) {
        console.log('subscribe succeed:', res);
      },
      onFailure: function (err) {
        MqttApi.callbackObject.forEach((item, index) => {
          if (item.topic === obj.topic) {
            MqttApi.callbackObject.splice(index, 1);
          }
        });
        console.warn('subscribe failure:', err);
      },
    });
  },
  closeSubscribe(obj) {
    if (!this.MqttSate) {
      console.warn('MQTT automatically reunsubscribes after three seconds of non-connection');
      setTimeout(() => {
        MqttApi.closeSubscribe(obj);
      }, 3000);
      return;
    }
    this.Client.unsubscribe(obj.topic, {
      invocationContext: {},
      onSuccess: function (res) {
        console.log('Subscribe close succeed:', res);
      },
      onFailure: function (err) {
        console.warn('Subscribe close failure:', err);
      },
    });
  },
  Uint8ArrayToString: function (array) {
    var out, i, len, c;
    var char2, char3;

    out = '';
    len = array.length;
    i = 0;
    while (i < len) {
      c = array[i++];
      switch (c >> 4) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
          // 0xxxxxxx
          out += String.fromCharCode(c);
          break;
        case 12:
        case 13:
          // 110x xxxx   10xx xxxx
          char2 = array[i++];
          out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = array[i++];
          char3 = array[i++];
          out += String.fromCharCode(
            ((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0)
          );
          break;
        default:
      }
    }
    return JSON.parse(out);
  },
};

export { MqttApi };

/* //连接示例 配置参数
MqttApi.parameter = {
  ip: '127.0.0.1',
  port: 1883,
  ClientID: '',
  username: 'admin',
  password: 'admin',
};
//建立连接
MqttApi.init();

//订阅
MqttApi.subscriptionApi(
  {
    topic: 'test/topic',
  },
  res => {
    console.log('callback:', res);
  }
);

//发布
MqttApi.publishApi({
  topic: 'test/topic',
  payload: {
    name: 'test',
    value: 'test',
  },
});

//取消订阅
MqttApi.closeSubscribe({
  topic: 'test/topic',
}); */

MqttApi.init();
